import styled from "styled-components";

const Title = styled.h1`
    margin-bottom: 20px;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 1.6rem;
    font-weight: 300;
    line-height: 2.1rem;
    color: #000;
    text-transform: ${props => props.textTransform || "none"};
    letter-spacing: 0.8px;

    > strong {
        font-weight: bold;
    }
`;

export default Title;
